import FloatingVue from 'floating-vue'
import naive from 'naive-ui'
import Toast from 'vue-toastification'

export default {
  install: (app) => {
    app.use(FloatingVue)
    app.use(naive)
    app.use(Toast)
  }
}
